 /**
 * Setup: add the below script include to pages that have a checkout button
 * 
 * <script src="{{ 'skio-volume-discount.js' | asset_url }}" defer="defer"></script>
 * 
 * Make sure the selector below covers all checkout buttons
 */

// scope variables
document.addEventListener('DOMContentLoaded', async function () {
  let stateChanged = false;
  
  const { rules } = await (await fetch(`https://api.skio.com/storefront-http/get-rules-by-domain-or-hostname?domain=${window?.Shopify?.shop}`)).json();
  
  async function applyVolumeDiscount () {
    const cart = await (await fetch('/cart.js')).json()
    stateChanged = false;
  
    // Check each rule to find the eligible rule 
    // with the largest min quantity
    let largestMinQuantity = {
      value: -1,
      index: -1,
    }
    
    rules.forEach((rule, index) => {
      if (rule.code &&
          largestMinQuantity.value < rule.minQuantityToDiscount
      ) {
        // Gets the count of eligible items in the cart for this rule
        const eligibleCount = cart.items.reduce(
          (aggregate, item) => rule.productVariantIds.some(gid => gid.includes(item.id)) ? 
              aggregate + item.quantity : aggregate 
          , 0)
        if (rule.minQuantityToDiscount <= eligibleCount) {
          largestMinQuantity.value = rule.minQuantityToDiscount
          largestMinQuantity.index = index
        }
      }
    })
  
    const rule = largestMinQuantity.index > -1 ? rules[largestMinQuantity.index] : null

    // Apply code
    if (rule && rule.code !== window.localStorage.getItem('skio_applied_rule_code')) {
      await fetch(`/discount/${rule.code}`);
      window.localStorage.setItem('skio_applied_rule_code', rule.code);
      stateChanged = true;
    }
  }
  
  window.AMP_CART_UPDATED = () => {
    console.log('AMP_CART_UPDATED');
    applyVolumeDiscount().then(() => {
      if (stateChanged) {
        window.AMP_API.OPEN_CART();
      }
    });
  };
  window.AMP_CART_OPENED = () => {
    console.log('AMP_CART_OPENED');
    applyVolumeDiscount().then(() => {
      if (stateChanged) {
        window.AMP_API.OPEN_CART();
      }
    });
  };
  // document.addEventListener('rebuy:cart.change', (event) => {
  //   applyVolumeDiscount();
  // });
  // document.addEventListener('rebuy:smartcart.show', (event) => {
  //   applyVolumeDiscount();
  // });
})